import { GtfsData, StopsByLine, StopsByDestination, StopPoint } from "./types";

// interface NamedDict {
//   [key: string]: any;
// }
//
// function sortByNumberThenDestinationName(stopsByLine: NamedDict): NamedDict {
//   let ordered: NamedDict = {};
//   let sortedKeys = Object.keys(stopsByLine).sort(function(a, b) {
//     let amatches = a.match(/^0*(\d*)(.*)$/);
//     if (amatches) {
//       let aNum = amatches[1];
//       let bmatches = b.match(/^0*(\d*)(.*)$/);
//       if (bmatches) {
//         let bNum = bmatches[1];
//         if (aNum && bNum) {
//           let numdiff = parseInt(aNum) - parseInt(bNum);
//           if (numdiff != 0) {
//             return numdiff;
//           }
//         }
//       }
//     }
//     if (a == b) return 0;
//     return a > b ? 1 : -1;
//   });
//
//   sortedKeys.forEach(function(key) {
//     ordered[key] = stopsByLine[key];
//   });
//   return ordered;
// }

// export default function(data: GtfsData, isStopId: boolean) {
export default function(data: GtfsData): StopsByLine[] {
  if (Object.values(data.stops).length < 1) {
    throw "Aucun arret disponible pour le moment";
  }

  let stopsByLines: { [key: string]: StopsByLine } = {};
  // let selectedLine = "";
  let stopareas = data.stops;
  for (let i in stopareas) {
    let stoparea = stopareas[i];
    let dests = stoparea.dests;

    if (stoparea.isCommercial && stoparea.spoints) {
      stoparea.spoints.forEach(function(spoint) {
        dests = dests.concat(spoint.dests);
      });
    }

    dests.forEach(function(dest) {
      // let lineName = dest.service + " " + dest.name;
      // let lineName = dest.id + " " + dest.name;
      // if (dest.service) {
      //   lineName = data.lines[dest.service].mnemo + " " + dest.name;
      // }
      let line = data.lines[dest.service];
      if (line){
        if (!stopsByLines[line.mnemo])
          stopsByLines[line.mnemo] = { line, stopsByDestinations: [] };

        let lineDests = stopsByLines[line.mnemo].stopsByDestinations;
        let destKey = lineDests.findIndex(
          currDest => currDest.destinationName == dest.name
        );
        if (destKey < 0) {
          destKey = stopsByLines[line.mnemo].stopsByDestinations.length;
          let destination: StopsByDestination = {
            destinationName: dest.name,
            stopsRefs: []
          };
          stopsByLines[line.mnemo].stopsByDestinations.push(destination);
        }
        stopsByLines[line.mnemo].stopsByDestinations[destKey].stopsRefs.push(
          stoparea.ref
        );
      }

      // if (stoparea.ref == isStopId) {
      //   stoparea.isCurrent = true;
      //   // selectedLine = lineName;
      //   stopsByLines[lineName].isCurrent = true;
      // } else {
      //   stoparea.isCurrent = false;
      // }

      // if (Array.isArray(stopsByLines[lineName])) {
      //   (stopsByLines[lineName]).push(stoparea);
      // }
    });
  }

  return Object.values(stopsByLines).sort(
    (a, b) => a.line.order - b.line.order
  );
  // return { stops:ordered, selected: selectedLine };
}
